import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {AppDispatch} from "../index";
import {userLogin,userRegister,authToken,Activity, mainData, ImagesDomain, ActivityType} from "../../models/commonModels"
import runningHttpClient from "../../axios";
import { AxiosError } from "axios";

interface InitSt{
    user:userLogin|null,
    isAuth:boolean,
    isFetching:boolean,
    error:string|null;
    token:authToken|null;
    maim:mainData,
    profileId:number|null,
    activity_type:ActivityType|null
}

const init:InitSt={
    user:null,
    isAuth:false,
    isFetching:false,
    error:null,
    token:null,
    maim:{amount:0, count_user:0, distance_length:0, activity_distance:0},
    profileId:null,
    activity_type:null
}

const AppSlice = createSlice({
    name:"taskListDetailSlice",
    initialState:init,
    reducers:{
        fetching(state, action:PayloadAction<boolean>){
            state.isFetching = action.payload
        },
        fetchError(state, action:PayloadAction<string|null>){
            state.error=action.payload
        },
        setToken(state, action:PayloadAction<authToken>){
            state.token = action.payload;
        },
        fetchMain(state, action:PayloadAction<mainData>){
            state.maim=action.payload
        },
        setProfileId(state, action:PayloadAction<number|null>){
            state.profileId=action.payload
        },
        setActivityType(state, action:PayloadAction<ActivityType>){
            state.activity_type=action.payload
        }
    }
})

export const{
    fetching,
    fetchError,
    setToken,
    fetchMain,
    setProfileId,
    setActivityType
}=AppSlice.actions;

export default AppSlice.reducer;


export const auth = (user:userLogin)=> async (dispatch:AppDispatch)=>{
    if(user.email==""){
        dispatch(fetchError("Не заполнен Email"))
        return
    }

    if(user.pswd==""){
        dispatch(fetchError("Не заполнен пароль"))
        return
    }

    dispatch(fetching(true))
    try{
        const res = await runningHttpClient.post<authToken>('login', user);
        if(res.status==200){
            dispatch(setToken(res.data))
            localStorage.setItem('token',res.data.token)
        }
    }catch(e){
        const err:AxiosError = e as AxiosError
        if(err.status==403){
            dispatch(fetchError("Пользователь с такими учетными данными не найден!!!"))
        }else{
            dispatch(fetchError(err.message))
        }
    }
    finally{
        setTimeout(function(){dispatch(fetching(false))}, 1000); 
    }
}

export const register=(user:userRegister)=> async(dispatch:AppDispatch)=>{
    
    if(user.email==""){
        dispatch(fetchError("Не заполнен email"))
        return
    }

    if(user.pswd==""){
        dispatch(fetchError("Не заполнен пароль"))
        return
    }

    if(user.pswd.length<8){
        dispatch(fetchError("Пароль должен содержать не менее 8 символов"))
        return
    }

    if(user.f_name==""){
        dispatch(fetchError("Не заполнено имя"))
        return
    }

    if(user.s_name==""){
        dispatch(fetchError("Не заполнена фамилия"))
        return
    }

    dispatch(fetching(true))
    try{
        const res = await runningHttpClient.post('register', user);
        if(res.status===200){
            dispatch(fetchError("Регистрация прошла успешно!!!"))
        }
    }catch(e){
            dispatch(fetchError((e as AxiosError).message))
    }finally{
         setTimeout(function(){dispatch(fetching(false))}, 1000); 
    }
}

export const getMainPage=()=>async(dispatch:AppDispatch)=>{
    dispatch(fetching(true))
    try{
        const res = await runningHttpClient.get<mainData>("main");
        dispatch(fetchMain(res.data));
    }catch(e){
        dispatch(fetchError((e as AxiosError).message))
    }finally{
        setTimeout(function(){dispatch(fetching(false))}, 3000); 
    }
}

export const activityUser = (token:string|null, 
                            user_distance:number, 
                            user_accept:string,
                            activity_day:string, 
                            file_name:string, 
                            fileBlob:Blob,
                            hour:number, 
                            min:number,
                            images:ImagesDomain[],
                            activityType:ActivityType) => async(dispatch:AppDispatch)=>{
    dispatch(fetching(true))
    const activity:Activity = {
        user_distance:user_distance,
        user_accept:user_accept,
        activity_day:activity_day,
        images:images,
        file_name:file_name,
        min_distance:min,
        hour_distance:hour,
        act_type:activityType
    }
    try{
        const res = await runningHttpClient.post('api/v1/user/activity', activity, {headers:{'Authorization':token}})
        // if(res.status=200){
        //     var formData = new FormData();
        //     formData.append("Files", fileBlob);
        //     const resImage = await runningHttpClient.post('stored/image', 
        //         formData, 
        //         {params:{a_id:res.data.activity_id}, 
        //         headers:{'Content-Type': 'multipart/form-data'}})
        // }   
        
    }catch(e){
        dispatch(fetchError((e as AxiosError).message))
        return false
    }finally{
        
        setTimeout(function(){dispatch(fetching(false))}, 1000); 
    }    
    return true;
}
